import { ReactNode, memo } from 'react';

import { Box } from '@mui/material';

import { createItemContainerSx } from './CommandPalette.styles';

export interface CommandPaletteItemProps<T> {
  item: T;
  isSelected: boolean;
  hasFocus: boolean;
  renderItem: (item: T, isSelected: boolean) => ReactNode;
  onItemSelect: (item: T) => void;
  onItemHover: (item: T) => void;
}

const CommandPaletteItemComponent = <T,>({
  item,
  isSelected,
  hasFocus,
  renderItem,
  onItemSelect,
  onItemHover,
}: CommandPaletteItemProps<T>) => {
  return (
    <Box
      sx={createItemContainerSx(hasFocus, isSelected)}
      onClick={() => onItemSelect(item)}
      onMouseEnter={() => onItemHover(item)}
    >
      {renderItem(item, hasFocus || isSelected)}
    </Box>
  );
};

export const CommandPaletteItem = memo(
  CommandPaletteItemComponent,
) as typeof CommandPaletteItemComponent;
